module.exports = __webpack_public_path__ + "img/eyeIcon.21c25804.svg";